(function () {
    function copyToClipboard(text) {
        if (navigator.clipboard && window.isSecureContext) {
            return navigator.clipboard.writeText(text);
        }

        return new Promise(function (resolve, reject) {
            var textarea = document.createElement('textarea');
            textarea.value = text;
            textarea.setAttribute('readonly', '');
            textarea.style.position = 'fixed';
            textarea.style.left = '-9999px';
            document.body.appendChild(textarea);
            textarea.select();

            try {
                if (document.execCommand('copy')) {
                    resolve();
                } else {
                    reject();
                }
            } catch (err) {
                reject(err);
            } finally {
                document.body.removeChild(textarea);
            }
        });
    }

    function getLabels() {
        var body = document.body;
        return {
            copy: body.getAttribute('data-code-copy') || 'Copy',
            copied: body.getAttribute('data-code-copied') || 'Copied!'
        };
    }

    function getCodeText(codeEl) {
        return codeEl.innerText.replace(/\n$/, '');
    }

    function addCopyButton(pre) {
        if (!pre || pre.closest('.code-block-wrap')) {
            return;
        }

        var code = pre.querySelector('code');
        if (!code) {
            return;
        }

        var labels = getLabels();
        var wrap = document.createElement('div');
        wrap.className = 'code-block-wrap';

        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'code-copy-btn';
        button.setAttribute('aria-label', labels.copy);
        button.textContent = labels.copy;

        pre.parentNode.insertBefore(wrap, pre);
        wrap.appendChild(button);
        wrap.appendChild(pre);

        button.addEventListener('click', function () {
            copyToClipboard(getCodeText(code)).then(function () {
                button.textContent = labels.copied;
                button.classList.add('is-copied');
                button.setAttribute('aria-label', labels.copied);

                window.setTimeout(function () {
                    button.textContent = labels.copy;
                    button.classList.remove('is-copied');
                    button.setAttribute('aria-label', labels.copy);
                }, 2000);
            }).catch(function () {
                window.prompt(labels.copy + ':', getCodeText(code));
            });
        });
    }

    function initCodeBlocks() {
        document.querySelectorAll('.gh-content pre, .kg-code-card pre').forEach(function (pre) {
            var code = pre.querySelector('code');

            if (code && typeof hljs !== 'undefined' && !code.classList.contains('hljs')) {
                hljs.highlightElement(code);
            }

            addCopyButton(pre);
        });
    }

    if (typeof hljs !== 'undefined') {
        hljs.configure({
            ignoreUnescapedHTML: true
        });
    }

    document.addEventListener('DOMContentLoaded', initCodeBlocks);
})();
